import McpLoading from ".";
import { SVGPureIcon } from '@/ui';

const McpTyping = ((props) => {
  const {
    className = '',
  } = props;

  return (
    <div className={`flex h-32px items-center mt-12px ${className}`}>
      <div className="w-56px h-32px bg-white border-2px border-black border-opacity-6 rounded-44px">
        <SVGPureIcon name="loading_anim" className="size-full" />
      </div>
    </div>
  )
});
export default McpTyping;